export const SPEAKER_SHOW_RESET = 'SPEAKER_SHOW_RESET';
export const SPEAKER_SHOW_SET_ERROR = 'SPEAKER_SHOW_SET_ERROR';
export const SPEAKER_SHOW_SET_RETRIEVED = 'SPEAKER_SHOW_SET_RETRIEVED';
export const SPEAKER_SHOW_TOGGLE_LOADING = 'SPEAKER_SHOW_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/speaker/show/mutation_types.js